import { defineAction } from 'redux-define';

const moduleName = defineAction('SIDEBAR');

export const TOGGLE_SIDEBAR = moduleName.defineAction('TOGGLE_SIDEBAR');
export const SET_IS_EXPANDED = moduleName.defineAction('SET_IS_EXPANDED');
export const INIT_VISIBILITY = moduleName.defineAction('INIT_VISIBILITY');
export const TOGGLE_SIDEBAR_CLOSE_BUTTON = moduleName.defineAction('TOGGLE_SIDEBAR_CLOSE_BUTTON');
